export default {
    props: {
        rangeStart: {
            type: Date,
            kComposite: 'range.start'
        }, 
        rangeEnd: {
            type: Date,
            kComposite: 'range.end'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateRangePicker/Range.js